import { LOAD_MORE_QUERY_PARAMETER_NAME, PAGE_QUERY_PARAMETER_NAME } from 'config/constants';
import { getQueryWithoutSlugTypeParameterFromParsedUrlQuery } from 'helpers/parsing/urlParsing';
import { pushQueries } from 'helpers/queryParams/pushQueries';
import { useRouter } from 'next/router';
import { UrlQueries } from 'types/urlQueries';

export const useUpdatePaginationQuery = () => {
    const router = useRouter();
    const query = getQueryWithoutSlugTypeParameterFromParsedUrlQuery(router.query) as UrlQueries;

    const updatePaginationQuery = (page: number) => {
        pushQueryPage(page);
    };

    const pushQueryPage = (page: number) => {
        const newQuery: UrlQueries = {
            ...query,
            [LOAD_MORE_QUERY_PARAMETER_NAME]: undefined,
            [PAGE_QUERY_PARAMETER_NAME]: page > 1 ? page.toString() : undefined,
        } as const;

        pushQueries(router, newQuery, true);
    };

    return updatePaginationQuery;
};
